// 淘宝店铺 大数据云  GIS开发代做 培训  
import "ol/ol.css";
import { Map, View } from "ol";
import TileLayer from "ol/layer/Tile";
import VectorLayer from "ol/layer/Vector.js";
import XYZ from "ol/source/XYZ";
import OSM from "ol/source/OSM";
import WMTS from "ol/source/WMTS";
import TileWMS from "ol/source/TileWMS";
import VectorSource from "ol/source/Vector.js";
import GeoJSON from "ol/format/GeoJSON.js";
import WKT from "ol/format/WKT";
import { Circle as CircleStyle, Fill, Stroke, Style, Text, Icon } from "ol/style.js";
import { transform, Projection, fromUserExtent } from "ol/proj";
import WMTSTileGrid from "ol/tilegrid/WMTS.js";
import { ScaleLine, defaults as defaultControls } from 'ol/control';
import MousePosition from 'ol/control/MousePosition';
import { createStringXY } from 'ol/coordinate';
import { defaults as defaultInteractions, Modify, Select } from 'ol/interaction';
import VectorTileLayer from 'ol/layer/VectorTile';
import VectorTileSource from 'ol/source/VectorTile';
import MVT from 'ol/format/MVT';
import Overlay from 'ol/Overlay';
import DoubleClickZoom from 'ol/interaction/DoubleClickZoom';
import * as turf from '@turf/turf';
import Feature from 'ol/Feature';
import Polygon from 'ol/geom/Polygon';

import Vue from "vue"
let mapEventEmiter = new Vue();
//主窗体地图对象
let mainMap = {};
let positionLayer = null;
let positionSource = null;
let overlay = {}
let circleLayer = null;
let circleLayerSource = null;
let enableGeoSearch = false;
let circleRadius = 10;

function init(viewConfig) {
    let projection4326 = getProjection(4326);
    var mousePositionControl = new MousePosition({
        coordinateFormat: createStringXY(4),
        projection: projection4326,
        className: 'custom-mouse-position',
        target: document.getElementById("ol-map-main-coor-id"),
        undefinedHTML: '&nbsp;'
    });

    let scaleControl = new ScaleLine({
        units: "metric",
        bar: true,
        steps: 4,
        text: true,
        minWidth: 140,
    });
    mainMap = new Map({
        target: "ol-map-main-id",
        controls: defaultControls({ attribution: false, zoom: false }).extend([mousePositionControl, scaleControl]),
        view: new View({
            projection: projection4326,
            center: viewConfig.center ? viewConfig.center : [113, 34],
            zoom: viewConfig.zoom ? viewConfig.zoom : 12,
            maxZoom: viewConfig.maxZoom ? viewConfig.maxZoom : 18,
            minZoom: viewConfig.minZoom ? viewConfig.minZoom : 2,
            extent: [115.1195, 39.6588, 116.3638, 40.3]
        }),

    });
    positionSource = new VectorSource();
    positionLayer = new VectorLayer({
        source: positionSource,
        zIndex: 1024,
        style: new Style({
            fill: new Fill({
                color: "red"
            }),
            stroke: new Stroke({
                color: "red",
                width: 2
            }),
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: "#ffcc33"
                })
            })
        })
    });

    mainMap.addLayer(positionLayer);

    // 新增一个圆图层 用于叠加分析
    circleLayerSource = new VectorSource();
    circleLayer = new VectorLayer({
        source: circleLayerSource,
        zIndex: 9999,
        style: new Style({
            fill: new Fill({
                color: "#fa01012b"
            }),
            stroke: new Stroke({
                color: "#fa010194",
                width: 1
            }),
            image: new CircleStyle({
                radius: 7,
                fill: new Fill({
                    color: "#ffcc33"
                })
            })
        })
    });
    mainMap.addLayer(circleLayer);
    mainMap.on("click", (event) => {
        if (enableGeoSearch) {
            var point = turf.point(event.coordinate);
            var extentFeature = turf.buffer(point, circleRadius, { units: 'kilometers' });

            let coordinates = extentFeature.geometry.coordinates;
            let coorStr = "";
            coordinates[0].forEach((point, index) => {
                coorStr += point.join(" ");
                if (index != coordinates[0].length - 1) {
                    index++;
                    coorStr += ","
                }
            })
            let extent_wkt = "SRID=4326;POLYGON ((" + coorStr + "))";
            mapEventEmiter.$emit("point-buffer", extent_wkt);

            if (circleLayer) {
                circleLayer.getSource().clear();
            }
            var searchWithinFeature = new Feature({
                geometry: new Polygon(coordinates),
                name: 'buffer'
            });
            circleLayer.getSource().addFeature(searchWithinFeature);
        } else {
            var features = mainMap.getFeaturesAtPixel(event.pixel);
            if (!features.length) {
                return;
            }
            mapEventEmiter.$emit("feature-selected", features[0]);
        }

    });

    //禁用双击缩放地图
    const dblClickInteraction = mainMap
        .getInteractions()
        .getArray()
        .find(interaction => {
            return interaction instanceof DoubleClickZoom;
        });
    mainMap.removeInteraction(dblClickInteraction);
    mapEventEmiter.$emit("map-ready", mainMap);
    return mainMap;
}
// 开启查找周边
function toggleGeoSearch(data) {
    enableGeoSearch = data;
    if (!data) {
        if (circleLayer) {
            circleLayer.getSource().clear();
        }
    }
}
// 设置查找半径
function setCircleSearchParam(radius) {
    if (radius) {
        circleRadius = radius;
    }
}

function getProjection(EPSG) {
    let projection;
    switch (EPSG) {
        default:
        case 4326:
            projection = new Projection({ code: 'EPSG:4326', units: 'degrees', axisOrientation: 'neu' });
            break;
        case 900913:
            projection = new Projection({ code: 'EPSG:900913', units: 'm', axisOrientation: 'neu' });;
            break;
        case 4490:
            projection = new Projection({ code: 'EPSG:4490', units: 'degrees', axisOrientation: 'neu' });
            break;
    }
    return projection;
}

function getOverLay() {
    return overlay;
}

function getMainMap() {
    return mainMap
}


function createXYZLayer(layerInfo) {
    let projection = getProjection(layerInfo.epsg);

    return new TileLayer({
        source: new XYZ({
            crossOrigin: 'anonymous',
            url: layerInfo.url,
            // projection: projection
            projection: "EPSG:900913"
            // 为什么不能使用getProjection 偏移了？
            // projection: layerInfo.epsg ? projection: "EPSG:3857",
        }),
        zIndex: layerInfo.z_index ? layerInfo.z_index : undefined,
        opacity: layerInfo.opacity ? layerInfo.opacity : 1,
        visible: layerInfo.visible ? layerInfo.visible : true,
        minZoom: layerInfo.min_zoom ? layerInfo.min_zoom : 18,
        maxZoom: layerInfo.max_zoom ? layerInfo.max_zoom : 1,
    });
}


function styleFn(attrs, resolution, layerInfo, type) {
    if (type == "Polygon" || type == "MultiPolygon") {
        //面  
        return new Style({
            fill: new Fill({
                color: layerInfo.setStyle(attrs.type, attrs).fill
            }),
            stroke: new Stroke({
                color: layerInfo.setStyle(attrs.type, attrs).stroke,
                width: 1
            }),
            text: (() => {
                let currentZoom = mainMap.getView().getZoom();
                let lableMinZoom = layerInfo.lable_min_zoom ? layerInfo.lable_min_zoom : layerInfo.min_zoom;
                let lableMaxZoom = layerInfo.lable_max_zoom ? layerInfo.lable_max_zoom : layerInfo.max_zoom;
                if (!layerInfo.lable_filed) {
                    return new Text()
                }
                if (!lableMinZoom && !lableMaxZoom) {
                    return new Text({
                        text: attrs[layerInfo.lable_filed],
                        scale: 1,
                        fill: new Fill({
                            color: "yellow"
                        })
                    })
                } else {
                    if (lableMaxZoom < currentZoom || currentZoom < lableMinZoom) {
                        return new Text()
                    } else {
                        return new Text({
                            text: attrs[layerInfo.lable_filed],
                            scale: 1,
                            fill: new Fill({
                                color: "yellow"
                            })
                        })
                    }
                }
            })()
        });
    } else if (type == "Point") {
        let scale = 0.5
        if (resolution > 0.00137329) {
            scale = 0.5
        }
        if (resolution > 0.005493) {
            scale = 0.5
        }
        //点  
        return new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: layerInfo.setStyle(attrs.type, attrs).stroke,
                }),
                fill: new Fill({
                    color: layerInfo.setStyle(attrs.type, attrs).fill
                })
            }),

            text: (() => {
                let currentZoom = mainMap.getView().getZoom();
                let lableMinZoom = layerInfo.lable_min_zoom ? layerInfo.lable_min_zoom : layerInfo.min_zoom;
                let lableMaxZoom = layerInfo.lable_max_zoom ? layerInfo.lable_max_zoom : layerInfo.max_zoom;
                if (!layerInfo.lable_filed) {
                    return new Text()
                }
                if (!lableMinZoom && !lableMaxZoom) {
                    return new Text({
                        text: attrs[layerInfo.lable_filed],
                        scale: 1.2,
                        offsetY: 15,
                        fill: new Fill({
                            color: layerInfo.setStyle(attrs.type, layerInfo).fill
                        })
                    })
                } else {
                    if (lableMaxZoom < currentZoom || currentZoom < lableMinZoom) {
                        return new Text()
                    } else {
                        return new Text({
                            text: attrs[layerInfo.lable_filed],
                            scale: 1.2,
                            offsetY: 15,
                            fill: new Fill({
                                color: layerInfo.setStyle(attrs.type, layerInfo).fill
                            })
                        })
                    }
                }
            })()
        });
    } else {
        //线
        return new Style({
            stroke: new Stroke({
                color: layerInfo.setStyle(attrs.type, attrs).fill,
                width: 2
            }),
            text: (() => {
                let currentZoom = mainMap.getView().getZoom();
                let lableMinZoom = layerInfo.lable_min_zoom ? layerInfo.lable_min_zoom : layerInfo.min_zoom;
                let lableMaxZoom = layerInfo.lable_max_zoom ? layerInfo.lable_max_zoom : layerInfo.max_zoom;
                if (!layerInfo.lable_filed) {
                    return new Text()
                }
                if (!lableMinZoom && !lableMaxZoom) {
                    return new Text({
                        text: attrs[layerInfo.lable_filed],
                        scale: 1,
                        offsetY: 10,
                        fill: new Fill({
                            color: "yellow"
                        }),
                        placement: "line"
                    })
                } else {
                    if (lableMaxZoom < currentZoom || currentZoom < lableMinZoom) {
                        return new Text()
                    } else {
                        return new Text({
                            text: attrs[layerInfo.lable_filed],
                            scale: 1,
                            offsetY: 10,
                            fill: new Fill({
                                color: "yellow"
                            }),
                            placement: "line"
                        })
                    }
                }
            })()
        })
    }
}

function drawCanvasImg2(attrs) {
    let canvas = document.createElement("canvas");
    canvas.width = 841.89;
    canvas.height = 595.28;
    let context2D = canvas.getContext("2d");
    context2D.lineWidth = 3;
    context2D.miterLimit = "10";
    context2D.beginPath();
    context2D.moveTo(420.484, 325.293);
    context2D.bezierCurveTo(420.484, 325.293, 333.91999999999996, 344.6, 282.10299999999995, 325.594);
    context2D.bezierCurveTo(230.28899999999996, 306.591, 259.9359999999999, 253.355, 314.57099999999997, 286.002);
    context2D.bezierCurveTo(369.2, 318.646, 420.484, 325.293, 420.484, 325.293);
    context2D.closePath();
    context2D.fillStyle = attrs.legend1 > 0 ? "#da8c42" : "#ffffff00";
    context2D.strokeStyle = "#da8c42";
    context2D.stroke();
    context2D.fill();
    context2D.restore();
    context2D.beginPath();
    context2D.moveTo(418.682, 320.577);
    context2D.bezierCurveTo(418.682, 320.577, 339.20000000000005, 310.076, 307.713, 272.967);
    context2D.bezierCurveTo(276.22400000000005, 235.85699999999997, 327.995, 192.426, 354.552, 244.26999999999998);
    context2D.bezierCurveTo(381.111, 296.111, 418.682, 320.577, 418.682, 320.577);
    context2D.closePath();
    context2D.fillStyle = attrs.legend2 > 0 ? "#ff0000" : "#ffffff00";
    context2D.strokeStyle = "#ff0000";
    context2D.stroke();
    context2D.fill();
    context2D.restore();
    context2D.beginPath();
    context2D.moveTo(419.277, 319.203);
    context2D.bezierCurveTo(419.277, 319.203, 358.98199999999997, 266.36199999999997, 353.379, 218.01799999999997);
    context2D.bezierCurveTo(347.776, 169.67199999999997, 414.94500000000005, 162.26899999999998, 408.271, 220.13499999999996);
    context2D.bezierCurveTo(401.598, 278, 419.277, 319.203, 419.277, 319.203);
    context2D.closePath();
    context2D.fillStyle = attrs.legend3 > 0 ? "#ff55ff" : "#ffffff00";
    context2D.strokeStyle = "#ff55ff";
    context2D.stroke();
    context2D.fill();
    context2D.restore();
    context2D.beginPath();
    context2D.moveTo(423.312, 321.013);
    context2D.moveTo(422.445, 319.915);
    context2D.bezierCurveTo(422.445, 319.915, 480.473, 264.593, 484.044, 216.05700000000002);
    context2D.bezierCurveTo(487.616, 167.52, 420.19599999999997, 162.93800000000002, 429.291, 220.47400000000002);
    context2D.bezierCurveTo(438.383, 278.009, 422.445, 319.915, 422.445, 319.915);
    context2D.closePath();
    context2D.fillStyle = attrs.legend4 > 0 ? "#02f7e7" : "#ffffff00";
    context2D.strokeStyle = "#02f7e7";
    context2D.stroke();
    context2D.fill();
    context2D.restore();
    context2D.beginPath();
    context2D.moveTo(423.312, 321.013);
    context2D.bezierCurveTo(423.312, 321.013, 502.371, 307.688, 532.516, 269.47999999999996);
    context2D.bezierCurveTo(562.6619999999999, 231.27199999999996, 509.37699999999995, 189.71199999999996, 484.68399999999997, 242.46899999999997);
    context2D.bezierCurveTo(459.987, 295.225, 423.312, 321.013, 423.312, 321.013);
    context2D.closePath();
    context2D.fillStyle = attrs.legend5 > 0 ? "#fceb21" : "#ffffff00";
    context2D.strokeStyle = "#fceb21";
    context2D.stroke();
    context2D.fill();
    context2D.restore();
    context2D.beginPath();
    context2D.moveTo(422.608, 324.946);
    context2D.bezierCurveTo(422.608, 324.946, 509.539, 342.523, 560.9639999999999, 322.48900000000003);
    context2D.bezierCurveTo(612.39, 302.45700000000005, 581.6869999999999, 249.82100000000003, 527.7149999999999, 283.55100000000004);
    context2D.bezierCurveTo(473.748, 317.277, 422.608, 324.946, 422.608, 324.946);
    context2D.closePath();
    context2D.fillStyle = attrs.legend6 > 0 ? "#393939" : "#ffffff00";
    context2D.strokeStyle = "#393939";
    context2D.stroke();
    context2D.fill();
    context2D.save();
    return canvas;
}

function baseVectorStyleFn(attrs, resolution, layerInfo, type) {
    if (type == "Polygon" || type == "MultiPolygon") {
        //面  
        return new Style({
            fill: new Fill({
                color: layerInfo.setStyle(attrs.type, layerInfo).fill
            }),
            stroke: new Stroke({
                color: layerInfo.setStyle(attrs.type, layerInfo).stroke,
                width: 1
            }),
            text: (() => {
                let currentZoom = mainMap.getView().getZoom();
                let lableMinZoom = layerInfo.lable_min_zoom ? layerInfo.lable_min_zoom : layerInfo.min_zoom;
                let lableMaxZoom = layerInfo.lable_max_zoom ? layerInfo.lable_max_zoom : layerInfo.max_zoom;
                if (!layerInfo.lable_filed) {
                    return new Text()
                }
                if (!lableMinZoom && !lableMaxZoom) {
                    return new Text({
                        text: attrs[layerInfo.lable_filed],
                        scale: 1,
                        offsetY: 30,
                        // font:'font-family:STHeiti,"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu ',
                        fill: new Fill({
                            color: "#fff",
                            stroke: new Stroke({
                                color: "#000000",
                                width: 2
                            }),
                        })
                    })
                } else {
                    if (lableMaxZoom < currentZoom || currentZoom < lableMinZoom) {
                        return new Text()
                    } else {
                        return new Text({
                            text: attrs[layerInfo.lable_filed],
                            scale: 1,
                            // font:'font-family:STHeiti,"Microsoft YaHei",微软雅黑,"MicrosoftJhengHei",华文细黑,STHeiti,MingLiu ',
                            fill: new Fill({
                                color: "#fff"
                            }),
                            offsetY: 30,
                            stroke: new Stroke({
                                color: "#000000",
                                width: 2
                            }),
                        })
                    }
                }
            })()
        });
    }
    //  else if (type == "Point") {
    //     let scale = 0.2
    //     if (layerInfo.name != "乡镇边界") { 
    //         scale = 0.15
    //     }

    //     //点
    //     return new Style({ 
    //         image: new Icon({
    //             scale: scale,
    //             img: drawCanvasImg2(attrs),
    //             imgSize: [841.89, 595.28],
    //         }),
    //         text: (() => {
    //             let currentZoom = mainMap.getView().getZoom();
    //             let lableMinZoom = layerInfo.lable_min_zoom ? layerInfo.lable_min_zoom : layerInfo.min_zoom;
    //             let lableMaxZoom = layerInfo.lable_max_zoom ? layerInfo.lable_max_zoom : layerInfo.max_zoom;
    //             if (!layerInfo.lable_filed) {
    //                 return new Text()
    //             }
    //             if (!lableMinZoom && !lableMaxZoom) {
    //                 return new Text({
    //                     text: attrs[layerInfo.lable_filed],
    //                     scale: 1.2,
    //                     offsetY: 0,
    //                     fill: new Fill({
    //                         color: layerInfo.setStyle(attrs.type, layerInfo).fill
    //                     })
    //                 })
    //             } else {
    //                 if (lableMaxZoom < currentZoom || currentZoom < lableMinZoom) {
    //                     return new Text()
    //                 } else {
    //                     return new Text({
    //                         text: attrs[layerInfo.lable_filed],
    //                         scale: 1.2,
    //                         offsetY: 0,
    //                         fill: new Fill({
    //                             color: layerInfo.setStyle(attrs.type, layerInfo).fill
    //                         })
    //                     })
    //                 }
    //             }
    //         })()
    //     });
    // }
     else {
        //线
        return new Style({
            stroke: new Stroke({
                color: layerInfo.setStyle(attrs.type, layerInfo).fill,
                width: 2
            }),
            text: (() => {
                let currentZoom = mainMap.getView().getZoom();
                let lableMinZoom = layerInfo.lable_min_zoom ? layerInfo.lable_min_zoom : layerInfo.min_zoom;
                let lableMaxZoom = layerInfo.lable_max_zoom ? layerInfo.lable_max_zoom : layerInfo.max_zoom;
                if (!layerInfo.lable_filed) {
                    return new Text()
                }
                if (!lableMinZoom && !lableMaxZoom) {
                    return new Text({
                        text: attrs[layerInfo.lable_filed],
                        scale: 1,
                        offsetY: 10,
                        fill: new Fill({
                            color: "yellow"
                        }),
                        placement: "line"
                    })
                } else {
                    if (lableMaxZoom < currentZoom || currentZoom < lableMinZoom) {
                        return new Text()
                    } else {
                        return new Text({
                            text: attrs[layerInfo.lable_filed],
                            scale: 1,
                            offsetY: 10,
                            fill: new Fill({
                                color: "yellow"
                            }),
                            placement: "line"
                        })
                    }
                }
            })()
        })
    }
}

function styleFn2(attrs, resolution, layerInfo, type) {
    if (type == "Polygon" || type == "MultiPolygon") {
        //面  
        return new Style({
            fill: new Fill({
                color: "#0d53f169",
            }),
            stroke: new Stroke({
                color: "#0d53f1",
                width: 1
            }),
            text: new Text()
        });
    } else if (type == "Point") {
        //点
        return new Style({
            image: new CircleStyle({
                radius: 5,
                stroke: new Stroke({
                    color: "#0d53f1",
                }),
                fill: new Fill({
                    color: "#0d53f169",
                })
            }),
            text: new Text()
        });
    } else {
        //线
        return new Style({
            stroke: new Stroke({
                color: "#0d53f1",
                width: 2
            }),
            text: new Text()
        })
    }
}

function createBaseVectorLayer(layerInfo) {
    let projection = getProjection(4326);

    let vectorLayer = new VectorLayer({
        renderMode: "image",
        source: new VectorSource({
            crossOrigin: 'anonymous',
            projection: projection,
            features: (new GeoJSON()).readFeatures({ "type": "FeatureCollection", "features": [] })
        }),
        zIndex: layerInfo.z_index ? layerInfo.z_index : undefined,
        minZoom: layerInfo.min_zoom ? layerInfo.min_zoom : 18,
        maxZoom: layerInfo.max_zoom ? layerInfo.max_zoom : 1,
    });

    //设置样式 
    vectorLayer.setStyle((feature, resolution) => {
        let type = feature.getGeometry().getType();
        return baseVectorStyleFn(feature.getProperties(), resolution, layerInfo, type);
    })
    return vectorLayer;
}
function createGeoJsonLayer(layerInfo) {
    let projection = getProjection(4326);

    let vectorLayer = new VectorLayer({
        renderMode: "image",
        source: new VectorSource({
            crossOrigin: 'anonymous',
            projection: projection,
            features: (new GeoJSON()).readFeatures({ "type": "FeatureCollection", "features": [] })
        }),
        zIndex: layerInfo.z_index ? layerInfo.z_index : undefined,
        minZoom: layerInfo.min_zoom ? layerInfo.min_zoom : 18,
        maxZoom: layerInfo.max_zoom ? layerInfo.max_zoom : 1,
    });

    //设置样式 
    vectorLayer.setStyle((feature, resolution) => {
        let type = feature.getGeometry().getType();
        return styleFn(feature.getProperties(), resolution, layerInfo, type);
    })
    return vectorLayer;
}
function createGeoJsonLayer2(layerInfo) {
    let projection = getProjection(4326);
    let vectorLayer = new VectorLayer({
        renderMode: "image",
        source: new VectorSource({
            crossOrigin: 'anonymous',
            projection: projection,
            features: (new GeoJSON()).readFeatures({ "type": "FeatureCollection", "features": layerInfo.features })
        }),
        zIndex: layerInfo.zIndex ? layerInfo.zIndex : 9527,
        maxZoom: 18,
        minZoom: 1,
    });

    //设置样式
    vectorLayer.setStyle((feature, resolution) => {
        let type = feature.getGeometry().getType();
        return styleFn2(feature.getProperties(), resolution, layerInfo, type);
    })
    return vectorLayer;
}
function createLayer(layerInfo) {
    let layer = null;
    switch (layerInfo.layer_type) {
        case "xyz":
            layer = createXYZLayer(layerInfo)
            break;
        case "geoJson":
            layer = createGeoJsonLayer(layerInfo);
            break;
        case "baseVector":
            layer = createBaseVectorLayer(layerInfo);
            break;
        case "geoJsonUpload":
            layer = createGeoJsonLayer2(layerInfo);
            break;
        default:
            console.log("图层类型未知！")
            break;
    }
    if (!layer) {
        console.log("初始化图层出错！");
        return;
    }

    return layer;
}

function addLayer(layerInfo) {
    let layer = createLayer(layerInfo);
    if (layerInfo.selected) {
        mainMap.addLayer(layer);
    }
    return layer;
}

function addFlowerLayer(layerInfo) {
    let layer = createLayer(layerInfo);
    if (layerInfo.selected) {
        mainMap.addLayer(layer);
    }
    return layer;
}

function highLight(feature) { }

function location(geom_wkt) {
    if (positionLayer) {
        positionLayer.getSource().clear();
    }
    var wkt = new WKT();
    let feature = wkt.readFeature(geom_wkt.slice(10, geom_wkt.length));
    mainMap.getView().fit(feature.getGeometry())
    positionLayer.getSource().addFeature(feature);
}

function clearLocation() {
    if (positionLayer) {
        positionLayer.getSource().clear();
    }
}
let xxMap = {
    getMainMap: getMainMap,
    highLight: highLight,
    init: init, // 初始化地图 
    addLayer: addLayer,
    addFlowerLayer: addFlowerLayer,
    getOverLay: getOverLay,
    createLayer: createLayer,
    location: location,
    clearLocation: clearLocation,
    mapEventEmiter: mapEventEmiter,
    drawCanvasImg2: drawCanvasImg2,
    toggleGeoSearch: toggleGeoSearch,// 开启或关闭地图空间查询
    setCircleSearchParam: setCircleSearchParam,// 设置查询半径
};
export default xxMap;